import React, {useState, useEffect} from 'react';
import "./map.css";
import Heart from "../../images/SZ_hjarta.png";
import Pin from "../../images/pin.png";

const CustomPin = ({ name, volonteers, actionplan, citizensProposal, id, fieldRegion, mobile, searchPopUp, setSearchPopUp, searchName, setSearchName, setApply}) => {
    const [selectedPin, setSelectedPin] = useState("");
    const [citizenProposal, setCitizensProposal] = useState(false);
    const [showPin, setShowPin] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false);
    const [plan, setPlan] = useState("");
    const [doublePin, setDoublePin] = useState(false);
    
    let imageSrc = volonteers >= 1 ? Heart : Pin;
    let secondImageSrc = Pin;

    useEffect(()=> { 
      !fieldRegion && volonteers >= 1 && citizensProposal && setDoublePin(true);
      !fieldRegion && (volonteers >= 1 || citizensProposal) && setShowPin(true);
      !searchName && volonteers < 1 && !citizensProposal && (fieldRegion === id) && setShowPopUp(true);
      citizensProposal ? setCitizensProposal("Ja") : setCitizensProposal("Nej");
      actionplan ? setPlan("Ja") : setPlan("Nej");

    },[volonteers, citizensProposal, fieldRegion, actionplan, id, selectedPin, searchPopUp, searchName]);

    const clearSearchPopUp = () => {
      setSearchName('');
      setSearchPopUp(false);
    }
   
   const onMouseEnter = (id) => {
     if (!searchPopUp){
      setSelectedPin(id);
      setShowPopUp(true);
     }
   }

   const onMouseLeave= () => {
      setSelectedPin("");
      setShowPopUp(false);
   }

   const handleOnClick = (id) => {
    if (!searchPopUp){
      selectedPin === id ? setSelectedPin("") : setSelectedPin(id);
      selectedPin === id ? setShowPopUp(true) : setShowPopUp(false);
    }
   }

    return(
       <div className="pin">
          {showPin && doublePin &&
          // eslint-disable-next-line
          <div className="pin-wrapper" onMouseEnter={() => onMouseEnter(id)} onMouseLeave={() => onMouseLeave()} onClick={()=> mobile && handleOnClick(id)}>
            <img className="pin-image-double" src={secondImageSrc} alt="red pin" />
            <img className="pin-image-double-heart" src={imageSrc} alt="heart" />
          </div> 
          }
          {showPin && !doublePin &&
          // eslint-disable-next-line
            <img className="pinImage" src={imageSrc} alt="pin marker" onMouseEnter={() => !mobile && onMouseEnter(id)} onMouseLeave={() => onMouseLeave()} onClick={()=> mobile && handleOnClick(id)} />
          }
          {showPopUp && 
            <div className="pin-info-box">
              <h3>{name}</h3>
              <p>{`Antal volontärer: ${volonteers}`}</p>
              <p>{`Medborgarförslag: ${citizenProposal}`}</p>
              <p>{`Handlingsplan: ${plan}`}</p>
            </div>
          }
          {searchPopUp && searchName === id &&
            <div className="pin-info-box">
               <div className= 'close-btn'>
                  <button onClick={()=> clearSearchPopUp()}>X</button>
               </div>
              <h3>{name}</h3>
              <p>{`Antal volontärer: ${volonteers}`}</p>
              <p>{`Medborgarförslag: ${citizenProposal}`}</p>
              <p>{`Handlingsplan: ${plan}`}</p>
              {volonteers === 0 && 
                <div className="apply-text">
                   <div className="small-divider" />
                  <p>Volontärer behövs i denna kommun, läs mer om hur du kan vara med och hjälpa i det förbyggande arbetet <a href="https://www.suicidezero.se/engagera-dig/bli-volontar-ditt-engagemang-raddar-liv">här.</a></p>
                  <p>Är du redan en <u>registrerad volontär</u> men önskar att engagera dig mer, klicka <button onClick={()=> setApply(true)}>här.</button></p>
                </div>
              }
            </div>
          }
        </div>
    );
};

export default CustomPin;